import axios from '@/resources/libs/axios'

export default {
    listByCountry(countryId) {
        return axios.get(`/vhe/auxiliaries/provinces-countries/provinces/list/all/${countryId}`)
    },
    listCountries() {
        return axios.get(`/vhe/auxiliaries/provinces-countries/countries/list/all`)
    },
}